(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* binding */ InformationSection; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
// EXTERNAL MODULE: ./components/molecules/OptimizedImage/index.tsx + 2 modules
var OptimizedImage = __webpack_require__(7841);
;// CONCATENATED MODULE: ./components/molecules/InformationSection/styled.ts


var styled_InformationSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "styled__InformationSection",
  componentId: "sc-1pm8nc-0"
})(function (_ref) {
  var topMargin = _ref.topMargin,
      highlightHeader = _ref.highlightHeader;
  return [{
    "display": "grid",
    "width": "100%",
    "gridTemplateColumns": "repeat(1, minmax(0, 1fr))",
    "@media (min-width: 1024px)": {
      "gridTemplateColumns": "repeat(2, minmax(0, 1fr))",
      "gridTemplateRows": "minmax(calc(100vh - 72px), min-content)",
      "scrollSnapAlign": "start"
    }
  }, topMargin && !highlightHeader && {
    "marginTop": "6rem"
  }, highlightHeader && {
    "marginTop": "2rem"
  }, highlightHeader && topMargin && {
    "@media (min-width: 1024px)": {
      "marginTop": "6rem"
    }
  }];
});
var InformationImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__InformationImageWrapper",
  componentId: "sc-1pm8nc-1"
})(["", " ", " > *{grid-column:1 / span 1;grid-row:1 / span 1;}"], {
  "height": "28rem",
  "width": "100%",
  "@media (min-width: 768px)": {
    "height": "40rem"
  },
  "@media (min-width: 1024px)": {
    "height": "100%",
    "maxHeight": "calc(100vh - 72px)"
  },
  "@media (max-height: 800px)": {
    "height": "25rem"
  }
}, {
  "position": "relative",
  "display": "grid",
  "@media (min-width: 1024px)": {
    "position": "sticky",
    "height": "calc(100vh - 72px)",
    "top": "72px"
  }
});
var InformationImage = (0,styled_components_browser_esm/* default */.ZP)(OptimizedImage/* OptimizedImage */.d).withConfig({
  displayName: "styled__InformationImage",
  componentId: "sc-1pm8nc-2"
})(["", ""], {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 196 37 / var(--tw-bg-opacity))",
  ".dark &": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(84 49 36 / var(--tw-bg-opacity))"
  }
});
var LinkImageAttribution = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "styled__LinkImageAttribution",
  componentId: "sc-1pm8nc-3"
})(["", " > div{", "}"], {
  "zIndex": "10",
  "placeSelf": "end"
}, {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(17 17 17 / var(--tw-bg-opacity))",
  "paddingLeft": "0.25rem",
  "paddingRight": "0.25rem",
  "fontSize": "0.75rem",
  "lineHeight": "1rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "opacity": "0.4"
});
var ImageAttribution = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__ImageAttribution",
  componentId: "sc-1pm8nc-4"
})(["", ""], {
  "zIndex": "10",
  "placeSelf": "end",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(17 17 17 / var(--tw-bg-opacity))",
  "paddingLeft": "0.25rem",
  "paddingRight": "0.25rem",
  "fontSize": "0.75rem",
  "lineHeight": "1rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "opacity": "0.4"
});
var HighlightedHeader = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "styled__HighlightedHeader",
  componentId: "sc-1pm8nc-5"
})(["", ""], {
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingBottom": "2rem",
  "fontSize": "1.5rem",
  "lineHeight": "2rem",
  ".dark &": {
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  "@media (min-width: 1024px)": {
    "display": "none"
  }
});
var InformationContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__InformationContent",
  componentId: "sc-1pm8nc-6"
})(["", " ", " > p:not(:first-of-type){", "}> ul{", "}"], {
  "alignSelf": "center",
  "padding": "1.5rem",
  ".dark &": {
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  "@media (min-width: 768px)": {
    "paddingLeft": "2.5rem",
    "paddingRight": "2.5rem"
  },
  "@media (min-width: 1024px)": {
    "paddingTop": "2rem",
    "paddingBottom": "2rem"
  },
  "@media (min-width: 1280px)": {
    "paddingLeft": "4rem",
    "paddingRight": "4rem"
  }
}, {
  "fontSize": "1.25rem",
  "lineHeight": "1.75rem"
}, {
  "paddingTop": "1.5rem"
}, {
  "listStylePosition": "outside",
  "listStyleType": "disc",
  "paddingTop": "1.5rem",
  "paddingInlineStart": "2rem"
});
var InformationContentHeader = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "styled__InformationContentHeader",
  componentId: "sc-1pm8nc-7"
})(function (_ref2) {
  var highlightHeader = _ref2.highlightHeader;
  return [{
    "paddingBottom": "1.5rem",
    "@media (min-width: 1536px)": {
      "paddingBottom": "2rem"
    }
  }, {
    "fontSize": "1.875rem",
    "lineHeight": "2.25rem",
    "@media (min-width: 1536px)": {
      "fontSize": "2.25rem",
      "lineHeight": "2.5rem"
    }
  }, highlightHeader && {
    "display": "none",
    "@media (min-width: 1024px)": {
      "display": "block"
    }
  }];
});
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/molecules/InformationSection/index.tsx




var InformationSection = function InformationSection(_ref) {
  var imageSrc = _ref.imageSrc,
      imageAttribution = _ref.imageAttribution,
      header = _ref.header,
      _ref$topMargin = _ref.topMargin,
      topMargin = _ref$topMargin === void 0 ? true : _ref$topMargin,
      children = _ref.children,
      _ref$highlightHeader = _ref.highlightHeader,
      highlightHeader = _ref$highlightHeader === void 0 ? false : _ref$highlightHeader,
      _ref$objectFit = _ref.objectFit,
      objectFit = _ref$objectFit === void 0 ? 'cover' : _ref$objectFit,
      objectPosition = _ref.objectPosition,
      _ref$priority = _ref.priority,
      priority = _ref$priority === void 0 ? false : _ref$priority;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styled_InformationSection, {
    topMargin: topMargin,
    highlightHeader: highlightHeader,
    children: [highlightHeader && header != null && /*#__PURE__*/(0,jsx_runtime.jsx)(HighlightedHeader, {
      children: header
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InformationImageWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InformationImage, {
        alt: '',
        src: imageSrc,
        priority: priority,
        objectFit: objectFit,
        objectPosition: objectPosition,
        layout: 'fill'
      }), imageAttribution != null && (imageAttribution.link != null ? /*#__PURE__*/(0,jsx_runtime.jsx)(LinkImageAttribution, {
        href: imageAttribution.link,
        target: '_blank',
        rel: 'noreferrer noopener',
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: imageAttribution.content
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ImageAttribution, {
        children: imageAttribution.content
      }))]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InformationContent, {
      children: [header != null && /*#__PURE__*/(0,jsx_runtime.jsx)(InformationContentHeader, {
        highlightHeader: highlightHeader,
        children: header
      }), children]
    })]
  });
};

/***/ }),

/***/ 7841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ OptimizedImage; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(2269);
// EXTERNAL MODULE: ../../node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(8421);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../packages/design-system/next-image/src/index.tsx


var _excluded = ["appEnv"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



/*
    Based on Example laid out by Cloudflare:
    https://developers.cloudflare.com/images/image-resizing/integration-with-frameworks/
*/



var normalizeSrc = function normalizeSrc(src) {
  return src.startsWith('/') ? src.slice(1) : src;
};

var cloudflareLoader = function cloudflareLoader(_ref) {
  var src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
  var params = ['fit=scale-down', "width=".concat(width)];

  if (quality) {
    params.push("quality=".concat(quality));
  }

  var paramsString = params.join(',');
  return "/cdn-cgi/image/".concat(paramsString, "/").concat(normalizeSrc(src));
};

var localLoader = function localLoader(_ref2) {
  var src = _ref2.src;
  return "/".concat(normalizeSrc(src));
};

var cloudflareEnvs = ['stage', 'production', 'sandbox2', 'eks-stage'];
var localEnvs = ['local', 'test'];
var NextOptimizedImage = function NextOptimizedImage(_ref3) {
  var appEnv = _ref3.appEnv,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref3, _excluded);

  var imageLoader = (0,react.useMemo)(function () {
    return cloudflareEnvs.includes(appEnv) ? cloudflareLoader : localEnvs.includes(appEnv) ? localLoader : undefined;
  }, [appEnv]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), _objectSpread({
    loader: imageLoader
  }, rest));
};
;// CONCATENATED MODULE: ../../packages/design-system/next-image/index.ts

/* harmony default export */ var next_image = (NextOptimizedImage);
// EXTERNAL MODULE: ./config/env.ts
var env = __webpack_require__(8199);
;// CONCATENATED MODULE: ./components/molecules/OptimizedImage/index.tsx


function OptimizedImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function OptimizedImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OptimizedImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OptimizedImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var OptimizedImage = function OptimizedImage(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(next_image, OptimizedImage_objectSpread({
    appEnv: env/* APP_ENV */.Wi
  }, props));
};

/***/ }),

/***/ 6751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ Shell; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
;// CONCATENATED MODULE: ./components/molecules/NavBar/styled.ts

var styled_NavBar = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "styled__NavBar",
  componentId: "sc-1pq2k3n-0"
})(["", " > div{", "}a{", "}"], {
  "position": "sticky",
  "zIndex": "10",
  "display": "grid",
  "width": "100%",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(0 0 0 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "opacity": "0.95",
  "gridTemplateRows": "72px",
  "top": "0",
  "height": "72px",
  "@media (min-width: 1024px)": {
    "scrollSnapAlign": "start"
  }
}, {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "@media (min-width: 1024px)": {
    "paddingLeft": "2.5rem",
    "paddingRight": "2.5rem"
  }
}, {
  "textDecorationLine": "none"
});
var Logo = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "styled__Logo",
  componentId: "sc-1pq2k3n-1"
})(["", " svg{", " path{fill:url('#custodia-mark_svg__a');}}span{", "}"], {
  "display": "flex",
  "alignItems": "center",
  "fontSize": "2.25rem",
  "lineHeight": "2.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
}, {
  "height": "2.5rem"
}, {
  "marginLeft": "0.5rem",
  "fontWeight": "700"
});
var NavItemTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__NavItemTitle",
  componentId: "sc-1pq2k3n-2"
})(function (_ref) {
  var isSelected = _ref.isSelected;
  return [{
    "paddingLeft": "0.75rem",
    "paddingRight": "0.75rem",
    "paddingTop": "0.25rem",
    "paddingBottom": "0.25rem",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))",
    ":hover": {
      "opacity": "0.7"
    }
  }, isSelected && {
    "fontWeight": "700"
  }];
});
var DesktopRightContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__DesktopRightContent",
  componentId: "sc-1pq2k3n-3"
})(["", ""], {
  "display": "flex"
});
var DesktopNavItems = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styled__DesktopNavItems",
  componentId: "sc-1pq2k3n-4"
})(["", ""], {
  "display": "none",
  "listStyleType": "none",
  "gridTemplateColumns": "repeat(3, auto)",
  "alignItems": "center",
  "gap": "3rem",
  "fontSize": "1.25rem",
  "lineHeight": "1.75rem",
  "@media (min-width: 1024px)": {
    "display": "grid"
  }
});
var MobileNavItems = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styled__MobileNavItems",
  componentId: "sc-1pq2k3n-5"
})(function (_ref2) {
  var menuOpen = _ref2.menuOpen;
  return [{
    "display": "none",
    "listStyleType": "none",
    "alignItems": "center",
    "paddingLeft": "0.5rem",
    "paddingRight": "0.5rem",
    "paddingTop": "1rem",
    "paddingBottom": "1rem",
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem",
    "marginTop": "-0.1rem"
  }, {
    "position": "sticky",
    "left": "0px",
    "zIndex": "10",
    "height": "calc(100vh - 72px + 0.1rem)",
    "width": "100%",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(0 0 0 / var(--tw-bg-opacity))",
    "top": "72px"
  }, menuOpen && {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "gap": "1.75rem",
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem",
    "@media (min-width: 1024px)": {
      "display": "none"
    }
  }];
});
var MobileMenuSpacer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__MobileMenuSpacer",
  componentId: "sc-1pq2k3n-6"
})(["", ""], {
  "width": "100%",
  "flexGrow": "1"
});
var MobileSubscribeButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__MobileSubscribeButtonWrapper",
  componentId: "sc-1pq2k3n-7"
})(["", " button{", "}"], {
  "width": "100%",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "paddingBottom": "1rem"
}, {
  "display": "block",
  "width": "100%"
});
var DarkModeButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styled__DarkModeButton",
  componentId: "sc-1pq2k3n-8"
})(["", ""], {
  "marginLeft": "1.5rem",
  "display": "none",
  "@media (min-width: 1024px)": {
    "display": "block"
  }
});
var MenuButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styled__MenuButton",
  componentId: "sc-1pq2k3n-9"
})(["", ""], {
  "padding": "0.25rem",
  "@media (min-width: 1024px)": {
    "display": "none"
  }
});
// EXTERNAL MODULE: ../../node_modules/react-icons/vsc/index.mjs
var vsc = __webpack_require__(8097);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./assets/custodia-mark.svg
var custodia_mark = __webpack_require__(5426);
// EXTERNAL MODULE: ./components/molecules/ColoredBorderWrapper/styled.ts
var styled = __webpack_require__(3419);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/molecules/ColoredBorderWrapper/index.tsx




var ColoredBorderWrapper = function ColoredBorderWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [children, /*#__PURE__*/(0,jsx_runtime.jsx)(styled/* Border */.O, {})]
  });
};
;// CONCATENATED MODULE: ./components/molecules/NavBar/index.tsx









var ROUTES = [{
  title: 'Avit',
  href: '/avit'
}, {
  title: 'Press',
  href: '/press'
}, {
  title: 'About',
  href: '/about'
}];
var NavBar = function NavBar() {
  var _useState = (0,react.useState)(false),
      menuOpen = _useState[0],
      setMenuOpen = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styled_NavBar, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: '/',
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Logo, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(custodia_mark/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "Custodia"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopRightContent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MenuButton, {
          onClick: function onClick() {
            return setMenuOpen(!menuOpen);
          },
          "aria-expanded": !!menuOpen,
          "aria-label": "Menu",
          "aria-controls": "nav-menu",
          children: menuOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)(vsc/* VscClose */.ven, {
            size: 25
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(vsc/* VscThreeBars */.QEj, {
            size: 25
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DesktopNavItems, {
          children: ROUTES.map(function (r) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(NavItem, {
              href: r.href,
              title: r.title
            }, r.href);
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MobileNavItems, {
      menuOpen: menuOpen,
      id: 'nav-menu',
      children: [ROUTES.map(function (r) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(NavItem, {
          href: r.href,
          title: r.title
        }, r.href);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MobileMenuSpacer, {})]
    })]
  });
};

var NavItem = function NavItem(_ref) {
  var href = _ref.href,
      title = _ref.title,
      external = _ref.external;
  var router = (0,next_router.useRouter)();
  var isCurrentRoute = !external && (router.route === href || // highlight "Avit" on /avit and any nested page (e.g. the redemption page)
  href === '/avit' && router.route.startsWith('/avit/'));

  var content = /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    children: isCurrentRoute ? /*#__PURE__*/(0,jsx_runtime.jsx)(ColoredBorderWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavItemTitle, {
        isSelected: isCurrentRoute,
        children: title
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(NavItemTitle, {
      isSelected: isCurrentRoute,
      children: title
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    children: external ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: href,
      children: content
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: href,
      children: content
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(2779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/design-system/footer/index.ts + 3 modules
var footer = __webpack_require__(2890);
// EXTERNAL MODULE: ./components/molecules/Shell/styled.ts
var Shell_styled = __webpack_require__(564);
// EXTERNAL MODULE: ./hooks/useIsBrowser.ts
var useIsBrowser = __webpack_require__(9612);
// EXTERNAL MODULE: ../../packages/design-system/cookie-banner/index.tsx + 4 modules
var cookie_banner = __webpack_require__(86);
;// CONCATENATED MODULE: ./components/molecules/Shell/index.tsx










var Shell = function Shell(_ref) {
  var _ref$enableSnapPoints = _ref.enableSnapPoints,
      enableSnapPoints = _ref$enableSnapPoints === void 0 ? false : _ref$enableSnapPoints,
      children = _ref.children;
  var isBrowser = (0,useIsBrowser/* useIsBrowser */.E)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Shell_styled/* ShellWrapper */.r, {
      className: classnames_default()({
        dark: true
      }),
      enableSnapPoints: enableSnapPoints,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Shell_styled/* ContentWrapper */.v, {
        children: children
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(footer/* default */.ZP, {}), isBrowser && /*#__PURE__*/(0,jsx_runtime.jsx)(cookie_banner/* default */.Z, {})]
    })
  });
};

/***/ }),

/***/ 909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/molecules/Seo/index.tsx
var Seo = __webpack_require__(1424);
// EXTERNAL MODULE: ./components/molecules/Shell/index.tsx + 3 modules
var Shell = __webpack_require__(6751);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
// EXTERNAL MODULE: ./components/molecules/OptimizedImage/index.tsx + 2 modules
var OptimizedImage = __webpack_require__(7841);
;// CONCATENATED MODULE: ./components/screens/home/styled.ts


var styled_Screen = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__Screen",
  componentId: "sc-125gfuq-0"
})(["", ""], {
  "display": "flex",
  "flexDirection": "column"
});
var FeatureImageSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "styled__FeatureImageSection",
  componentId: "sc-125gfuq-1"
})(["", " ", " ", " ", ""], {
  "width": "100%",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
}, {
  "display": "grid",
  "gridTemplateColumns": "repeat(1, minmax(0, 1fr))",
  "gridTemplateRows": "36rem",
  "@media (max-height: 800px)": {
    "gridTemplateRows": "auto"
  }
}, {
  "@media (min-width: 1024px)": {
    "gridTemplateRows": "40rem",
    "@media (max-height: 800px)": {
      "gridTemplateRows": "minmax(34rem, calc(100vh - 72px))"
    }
  }
}, {
  "@media (min-width: 1536px)": {
    "gridTemplateRows": "46rem",
    "@media (max-height: 800px)": {
      "gridTemplateRows": "minmax(36rem, calc(100vh - 72px))"
    }
  }
});
var FeatureImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__FeatureImageWrapper",
  componentId: "sc-125gfuq-2"
})(["", " ", ""], {
  "gridColumn": "1 / span 1",
  "gridRow": "1 / span 1"
}, {
  "position": "relative",
  "width": "100%",
  "zIndex": "1"
});
var FeatureImage = (0,styled_components_browser_esm/* default */.ZP)(OptimizedImage/* OptimizedImage */.d).withConfig({
  displayName: "styled__FeatureImage",
  componentId: "sc-125gfuq-3"
})(["", ""], {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 196 37 / var(--tw-bg-opacity))",
  ".dark &": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(84 49 36 / var(--tw-bg-opacity))"
  }
});
var FeatureImageOpacityOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__FeatureImageOpacityOverlay",
  componentId: "sc-125gfuq-4"
})(["", " background:linear-gradient(to right,rgba(0,0,0,1),rgba(0,0,0,0));"], {
  "gridColumn": "1 / span 1",
  "gridRow": "1 / span 1",
  "zIndex": "2"
});
var FeatureImageOverlayWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__FeatureImageOverlayWrapper",
  componentId: "sc-125gfuq-5"
})(["grid-column:1 / span 1;grid-row:1 / span 1;", " ", ""], {
  "width": "100%",
  "alignSelf": "center"
}, {
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "paddingTop": "4rem",
  "paddingBottom": "4rem",
  "zIndex": "3",
  "@media (min-width: 1024px)": {
    "paddingLeft": "5rem",
    "paddingRight": "5rem"
  }
});
var FeatureImageOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__FeatureImageOverlay",
  componentId: "sc-125gfuq-6"
})(["", " > h1{", "}> p{", "}"], {
  "display": "flex",
  "maxWidth": "36rem",
  "flexDirection": "column",
  "gap": "3rem",
  "@media (min-width: 1536px)": {
    "maxWidth": "48rem"
  }
}, {
  "fontSize": "2.25rem",
  "lineHeight": "2.5rem",
  "@media (min-width: 768px)": {
    "fontWeight": "600"
  },
  "@media (min-width: 1536px)": {
    "fontSize": "3rem",
    "lineHeight": "1"
  }
}, {
  "fontSize": "1.25rem",
  "lineHeight": "1.75rem",
  "@media (min-width: 1536px)": {
    "fontSize": "1.5rem",
    "lineHeight": "2rem"
  }
});
var FeatureImageSubscribeButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__FeatureImageSubscribeButtonWrapper",
  componentId: "sc-125gfuq-7"
})(["", " > a{", "}"], {
  "display": "block",
  "@media (min-width: 1024px)": {
    "display": "none"
  }
}, {
  "textDecorationLine": "none"
});
var ProductsSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "styled__ProductsSection",
  componentId: "sc-125gfuq-8"
})(["", " ", " ", " ", " > h2{", " ", " ", "}"], {
  "display": "grid",
  "gridTemplateColumns": "repeat(1, minmax(0, 1fr))",
  "gridTemplateRows": "repeat(2, min-content)"
}, {
  "@media (min-width: 1280px)": {
    "gridTemplateRows": "1fr min-content 2fr min-content 1fr",
    "@media (max-height: 800px)": {
      "gap": "1rem",
      "gridTemplateRows": "repeat(2, min-content)"
    }
  }
}, {
  "width": "100%",
  ".dark &": {
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  "@media (min-width: 1280px)": {
    "height": "calc(100vh - 72px)",
    "scrollSnapAlign": "start",
    "@media (max-height: 800px)": {
      "height": "min-content"
    }
  }
}, {
  "marginTop": "6rem",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "@media (min-width: 1024px)": {
    "marginBottom": "6rem"
  },
  "@media (min-width: 1280px)": {
    "marginTop": "0px",
    "marginBottom": "0px",
    "paddingLeft": "2.5rem",
    "paddingRight": "2.5rem",
    "@media (max-height: 800px)": {
      "marginTop": "6rem"
    }
  }
}, {
  "paddingBottom": "2rem",
  "textAlign": "center",
  "fontSize": "2.25rem",
  "lineHeight": "2.5rem",
  "fontStyle": "italic",
  "@media (min-width: 1024px)": {
    "fontSize": "3rem",
    "lineHeight": "1",
    "fontWeight": "600"
  },
  "@media (min-width: 1280px)": {
    "alignSelf": "flex-end"
  }
}, {
  "gridColumn": "1 / span 1",
  "gridRow": "1 / span 1"
}, {
  "@media (min-width: 1280px)": {
    "gridRow": "2 / span 1",
    "@media (max-height: 800px)": {
      "gridRow": "1 / span 1"
    }
  }
});
var ProductsSectionImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "styled__ProductsSectionImage",
  componentId: "sc-125gfuq-9"
})(["", " ", " ", " ", ""], {
  "objectFit": "cover",
  "gridColumn": "1 / span 1",
  "gridRow": "2 / span 1",
  "height": "25%"
}, {
  "@media (min-width: 640px)": {
    "height": "50%",
    "alignSelf": "flex-start"
  }
}, {
  "@media (min-width: 1280px)": {
    "height": "calc(100vh - 72px)",
    "objectFit": "scale-down",
    "gridRow": "1 / span 5",
    "@media (max-height: 800px)": {
      "objectFit": "cover",
      "gridRow": "1 / span 2"
    }
  }
}, {
  "width": "100%",
  "paddingTop": "3rem",
  "opacity": "0.1",
  ".dark &": {
    "opacity": "0.07"
  },
  "@media (min-width: 1280px)": {
    "paddingTop": "2rem",
    "paddingBottom": "2rem"
  }
});
var ProductsGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__ProductsGrid",
  componentId: "sc-125gfuq-10"
})(["", " ", " ", ""], {
  "marginTop": "7rem",
  "display": "grid",
  "width": "100%",
  "justifyItems": "center",
  ".dark &": {
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  "@media (min-width: 640px)": {
    "gridTemplateColumns": "repeat(2, minmax(0, 1fr))",
    "gap": "1.5rem"
  },
  "@media (min-width: 1024px)": {
    "rowGap": "4rem"
  },
  "@media (min-width: 1280px)": {
    "gridTemplateColumns": "repeat(2, minmax(0, 1fr))",
    "columnGap": "3rem"
  }
}, {
  "gridColumn": "1 / span 1",
  "gridRow": "2 / span 1"
}, {
  "@media (min-width: 1280px)": {
    "gridRow": "3 / span 1",
    "@media (max-height: 800px)": {
      "gridRow": "2 / span 1"
    }
  }
});
var ProductsGridItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__ProductsGridItem",
  componentId: "sc-125gfuq-11"
})(["", " > img{", "}> h3{", "}> div{", " ", " span{font-family:'Lora',serif;", "}}&:nth-child(2n){> div{", "}}&:nth-child(3n){", "}"], {
  "display": "flex",
  "flexDirection": "column",
  "paddingTop": "3rem",
  "height": "fit-content",
  "@media (min-width: 1024px)": {
    "paddingTop": "0px"
  }
}, {
  "marginLeft": "auto",
  "marginRight": "auto",
  "height": "5rem",
  "@media (min-width: 768px)": {
    "height": "6rem"
  }
}, {
  "width": "100%",
  "maxWidth": "20rem",
  "paddingTop": "2rem",
  "paddingBottom": "2rem",
  "textAlign": "center",
  "fontSize": "1.875rem",
  "lineHeight": "2.25rem",
  "fontWeight": "600",
  "@media (min-width: 1024px)": {
    "paddingTop": "3rem",
    "paddingBottom": "3rem"
  }
}, {
  "maxWidth": "20rem",
  "paddingLeft": "2rem",
  "@media (min-width: 768px)": {
    "marginLeft": "auto",
    "marginRight": "auto"
  }
}, {
  "@media (min-width: 1536px)": {
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem"
  }
}, {
  "fontSize": "0.75rem",
  "lineHeight": "1rem",
  "@media (min-width: 1536px)": {
    "fontSize": "1rem",
    "lineHeight": "1.5rem"
  }
}, {
  "@media (min-width: 768px)": {
    "paddingLeft": "0px"
  }
}, {
  "@media (min-width: 640px)": {
    "gridColumn": "span 2 / span 2"
  },
  "@media (min-width: 1280px)": {
    "gridColumn": "auto"
  }
});
var AsSeenOnBannerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__AsSeenOnBannerWrapper",
  componentId: "sc-125gfuq-12"
})(["", ""], {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(17 17 17 / var(--tw-bg-opacity))",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "@media (min-width: 1024px)": {
    "paddingLeft": "2.5rem",
    "paddingRight": "2.5rem"
  }
});
var AsSeenOnBanner = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styled__AsSeenOnBanner",
  componentId: "sc-125gfuq-13"
})(["", " ", " img{", "}"], {
  "display": "grid",
  "listStyleType": "none",
  "gridTemplateColumns": "repeat(4, minmax(0, 1fr))",
  "alignItems": "center",
  "columnGap": "2.5rem",
  "paddingTop": "1.5rem",
  "paddingBottom": "1.5rem",
  "@media (min-width: 1024px)": {
    "columnGap": "5rem"
  }
}, {
  "marginLeft": "auto",
  "marginRight": "auto",
  "width": "fit-content"
}, {
  "objectFit": "scale-down"
});
// EXTERNAL MODULE: ./components/molecules/InformationSection/index.tsx + 1 modules
var InformationSection = __webpack_require__(5288);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/screens/home/index.tsx






var Screen = function Screen() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Shell/* Shell */.N, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(styled_Screen, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FeatureImageSection, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FeatureImageWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FeatureImage, {
            alt: 'tetons',
            src: '/images/home/tetons.webp',
            layout: 'fill',
            objectFit: 'cover',
            objectPosition: '50% 26%',
            priority: true
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FeatureImageOpacityOverlay, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(FeatureImageOverlayWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FeatureImageOverlay, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
              children: "Custodia Bank\u2122 specializes in digital asset payment and custody solutions for U.S. commercial customers."
            })
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InformationSection/* InformationSection */.K, {
        imageSrc: '/images/home/chess.webp',
        header: 'A regulatorily compliant platform for businesses to manage cash, connect and transact.',
        highlightHeader: true,
        objectPosition: 'bottom',
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "As a chartered bank, Custodia operates under the first special purpose depository institution legal and regulatory framework in the United States."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Custodia services U.S.\u2013based business customers such as digital asset businesses, fintechs, banks, corporate treasurers, trusts, pension funds, start-ups, and many more. Ultimately, the strategy of Custodia is to serve customers worldwide."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(InformationSection/* InformationSection */.K, {
        imageSrc: '/images/home/vault-door.webp',
        imageAttribution: {
          content: 'Photo (edited) by danielsphotography / CC BY 2.0',
          link: 'https://creativecommons.org/licenses/by/2.0/'
        },
        header: 'We see a future where all banks support digital assets and offer meaningful API capabilities to tech-savvy customers.',
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Custodia is a new breed of bank \u2014 a software platform with a bank charter, built to connect digital assets with the traditional financial system in a safe and sound way. Custodia has a deep understanding of how digital assets can solve payment inefficiencies faced by our business customers. Custodia is a depository institution, which means we\u2019re eligible to become a U.S. dollar clearing bank at the Federal Reserve and, consequently, Custodia promises a superior regulatory structure relative to digital asset competitors."
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ./pages/index.tsx







var Page = function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Seo/* Seo */.p, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Screen, {})]
  });
};

/* harmony default export */ var pages = (Page);

/***/ }),

/***/ 7314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(909);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [946,250,421,456,774,888,179], function() { return __webpack_exec__(7314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);